export const Screens = {
  Any: {
    name: `Any`,
    path: (): string => `/*`,
  },
  Application: {
    name: `Application`,
    path: (): string => `/application`,
  },
  Error: {
    name: `Error`,
    path: (): string => `/error`,
  },
  Info: {
    name: `Info`,
    path: (): string => `/info`,
  },
  Login: {
    name: `Login`,
    path: (): string => `/login`,
  },
  Root: {
    name: `Root`,
    path: (): string => `/`,
  },
  Settings: {
    name: `Settings`,
    path: (): string => `/settings`,
  },
  Translations: {
    name: `Translations`,
    path: (): string => `/translations`,
  },
  TranslationsEdit: {
    name: `TranslationsEdit`,
    path: (id: string = `:id`): string => `translations/${id}/edit`,
  },
};
